import React, { useMemo } from "react";
import classes from "./cartPage.module.css";
import { useCartPage } from "../../Pregrine/CartPage/useCartPage";
import StockStatusMessage from "../../components/StockStatusMessage/StockStatusMessage";
import PriceSummary from "./PriceSummary/PriceSummary";
import ProductListing from "./ProductListing/productListing";
import YouMayAlsoLike from "./YouMayAlsoLike/YouMayAlsoLike";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import RecentlyViewedSection from "../../components/RecentlyViewedSection/RecentlyViewedSection";
import LoadingIndicator from "../../components/LoadingIndicator";

const CartPage = (props) => {
  const talonProps = useCartPage();

  const {
    cartItems,
    hasItems,
    isCartUpdating,
    fetchCartDetails,
    setIsCartUpdating,
    loading,
    recentlyViewedList,
    shouldShowLoadingIndicator,
  } = talonProps;

  const hasOutOfStockItem = useMemo(() => {
    if (cartItems) {
      const isOutOfStock = cartItems.find((cartItem) => {
        const { product } = cartItem;
        const { stock_status: stockStatus } = product;

        return stockStatus === "OUT_OF_STOCK";
      });

      return !!isOutOfStock;
    }
  }, [cartItems]);

  const productListing = shouldShowLoadingIndicator ? (
    <LoadingIndicator />
  ) : hasItems ? (
    <div className={`${classes.cart_details} mt-4`}>
      <ProductListing
        setIsCartUpdating={setIsCartUpdating}
        fetchCartDetails={fetchCartDetails}
      />
    </div>
  ) : !loading ? (
    <>
      <h3 className={classes.itemsMessage}>
        <span>There are no items in your cart.</span>
      </h3>
    </>
  ) : null;

  const priceSummary = hasItems ? (
    <PriceSummary
      setIsCartUpdating={setIsCartUpdating}
      isUpdating={isCartUpdating}
      hasOutOfStockItem={hasOutOfStockItem}
    />
  ) : null;

  const youMayAlsoLikeComponent = hasItems ? (
    <YouMayAlsoLike cartItems={cartItems} />
  ) : null;

  return (
    <>
      <section className="section-gap cartform">
        <div className="container mt-4 mb-5">
          {hasItems && <ProgressBar />}
          <div className={classes.body}>
            <div className={`${classes.items_container} `}>
              {productListing}
              <div className={classes.stockStatusMessageContainer}>
                <StockStatusMessage cartItems={cartItems} />
              </div>
            </div>
            <div className={classes.price_adjustments_container}>
              <div className={classes.ordersummary}>
                {hasItems ? (
                  <>
                    <div className={classes.priceSummary}>
                      {" "}
                      <h3 className="mb-0">
                        <b>Order Summary</b>
                      </h3>
                      <hr />
                      {priceSummary}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          {youMayAlsoLikeComponent}
          <RecentlyViewedSection
            headingStyle={classes.recentlyHeading}
            products={recentlyViewedList?.products?.items || []}
          />
        </div>
      </section>
    </>
  );
};

export default CartPage;
